



























import { Component, Prop, Vue } from "vue-property-decorator";
import i18n from "@/i18n";

@Component
export default class Drawer extends Vue {
  @Prop({
    type: String,
    default() {
      return "";
    },
  })
  public title!: string;

  @Prop({
    type: String,
    default() {
      return i18n.t('components.flow.drawer.text_7b5675655668') as string;
    },
  })
  public noticeMsg!: string;
    
  // 处理关闭提示
  async handleClose() {
    this.$emit('close');
  }
}
